import React from 'react';
import { TbBrandGithub, TbBrandLinkedin, TbMail } from 'react-icons/tb';
import { Link } from 'react-scroll';
import './Footer.css';

const NAV_LINKS = ['home', 'work', 'services', 'about', 'skills', 'contact'];

const SOCIALS = [
  { icon: <TbBrandGithub />, href: 'https://github.com/ObaidGits', label: 'GitHub' },
  { icon: <TbBrandLinkedin />, href: 'https://www.linkedin.com/in/obaidullah-zeeshan/', label: 'LinkedIn' },
  { icon: <TbMail />, href: 'mailto:obaidzeeshan.official@gmail.com', label: 'Email' },
];

const Footer = () => (
  <footer id="footer">
    <div className="footer-glow" aria-hidden="true" />
    <div className="container">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <span className="footer-logo">OZ</span>
          <p className="footer-tagline">Building things for the web &amp; beyond.</p>
          <div className="footer-socials">
            {SOCIALS.map(({ icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="footer-social-btn"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Nav links */}
        <nav className="footer-nav" aria-label="Footer navigation">
          <p className="footer-nav-label">Navigation</p>
          {NAV_LINKS.map(s => (
            <Link
              key={s}
              to={s}
              href={`/#${s}`}
              smooth
              duration={500}
              className="footer-nav-link"
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </Link>
          ))}
        </nav>

        {/* Quick contact */}
        <div className="footer-contact">
          <p className="footer-nav-label">Get In Touch</p>
          <a href="mailto:obaidzeeshan.official@gmail.com" className="footer-contact-link">
            obaidzeeshan.official@gmail.com
          </a>
          <a href="https://www.linkedin.com/in/obaidullah-zeeshan/" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
            LinkedIn Profile
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>
          Designed &amp; built by{' '}
          <span className="footer-name">Obaidullah Zeeshan</span>
          {' '}·{' '}
          <span className="footer-year" suppressHydrationWarning>{new Date().getFullYear()}</span>
        </p>
        <p className="footer-stack">React · Vite · Framer Motion · Netlify</p>
      </div>
    </div>
  </footer>
);

export default Footer;
